export default "__VITE_ASSET__621601b0__"